import SEO from "components/seo";
import Layout from "components/layout";
import LegalTranslation from "components/reusableComponents/Legaltranslation/LegalTranslation";
import React from "react";

function index() {
  const title = "Legal Translation Services | Tomedes";
  const description =
    "Legal translation services by professional legal translators. Tomedes provides instant legal translation quotes. Get the best combination of high quality and fast delivery legal translation services from Tomedes.";
  const keywords =
    "Clegal translation, professional legal translation, legal translation quote, Website translation, Document translation, Video translation";
  const slug = "/legal-translation.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <LegalTranslation />
    </Layout>
  );
}

export default index;
